import React, {useEffect, useState} from 'react';
import {Grid, Typography} from '@mui/material';
import LocationListItemListingImage from '../../location/search/LocationImages/LocationListItemListingImage';
import ImageNotAvailablePlaceholder from '../../location/ImageNotAvailablePlaceholder';
import {styled} from "@mui/material/styles";

// Location photos are stored at 4:3, so the card shows them whole; the text
// below stays to three short lines so the card stays about as tall as before.
const PHOTO_ASPECT_RATIO = '4 / 3';

const Main = styled('div')(() => ({
  width: '100%'
}));

interface LocationItemProps {
  listingImageFileName?: string | null;
  pricePerDay: number;
  pricePerMonth: number;
  instantApproval: boolean;
  locationName: string;
  cityName: string;
  distanceTo?: string;
}

const LocationItem = (props: LocationItemProps) => {
  const {listingImageFileName, pricePerDay, pricePerMonth, instantApproval, locationName, cityName, distanceTo} = props;

  const [price, setPrice] = useState(0);
  const [period, setPeriod] = useState('');

  useEffect(() => {
    const pricePerDayInDollars = pricePerDay / 100;
    const pricePerMonthInDollars = pricePerMonth / 100;

    setPrice(pricePerDayInDollars === 0 ? pricePerMonthInDollars : pricePerDayInDollars);
    setPeriod(pricePerDayInDollars === 0 ? 'mon' : 'day');
  }, [pricePerDay, pricePerMonth]);

  return (
    <Main>
      {
        listingImageFileName ?
          <LocationListItemListingImage aspectratio={PHOTO_ASPECT_RATIO}
                                        width={'100%'}
                                        borderRadius={'0'}
                                        objectfit={'cover'}
                                        listingImageFileName={listingImageFileName}/> :
          <ImageNotAvailablePlaceholder aspectratio={PHOTO_ASPECT_RATIO}
                                        width={'100%'}
                                        borderRadius={'0'}
                                        objectfit={'cover'}
          />
      }

      <div className="ss-location-quick-view-item-info">
        <Grid container wrap='nowrap' justifyContent='space-between' alignItems='center' columnGap={1}>
          <Grid item>
            {
              instantApproval ?
                <div className="ss-location-quick-view-item-approval-box instant-approval">
                  <Typography className="ss-location-quick-view-item-approval">Instant Approval</Typography>
                </div>
                :
                <div className="ss-location-quick-view-item-approval-box request-space">
                  <Typography className="ss-location-quick-view-item-approval">Request Space</Typography>
                </div>
            }
          </Grid>
          <Typography className="ss-location-quick-view-item-price" color="textPrimary" noWrap>${price}<strong
            className="ss-location-quick-view-item-price-units">/{period}</strong></Typography>
        </Grid>
        <Typography variant="h5" noWrap={true} color={'secondary'}
                    className={"ss-location-quick-view-item-title"}>{locationName}</Typography>
        <Typography variant="body2" noWrap className="ss-location-quick-view-item-city">
          USA, {cityName}{distanceTo ? ` · ${distanceTo} mi` : ''}
        </Typography>
      </div>
    </Main>
  )
}

export default LocationItem;
